import React, { Component } from 'react';
import ErrorPage from './ErrorPage';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // 使用新的ErrorPage组件显示错误信息
      return (
        <ErrorPage 
          errorInfo={{
            error: this.state.error && this.state.error.toString(),
            componentStack: this.state.errorInfo && this.state.errorInfo.componentStack
          }} 
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 